import React from "react";
import { Icons, IconButton, TooltipMessage, WithTooltip } from "@storybook/components";
import { styled } from "@storybook/theming";
const ProfileTooltip = ({ username, onLogout }) => (React.createElement(TooltipWrapper, null,
    React.createElement(TooltipMessage, { title: username && React.createElement(TooltipTitle, null, username), links: [{ onClick: onLogout, title: "Log out" }] })));
export default function HeaderButtons({ username, onZoomIn, onZoomOut, onZoomReset, onLogout }) {
    return (React.createElement(Container, null,
        React.createElement(IconButton, { className: "iconButton", onClick: onZoomIn, title: "Zoom in" },
            React.createElement(Icons, { icon: "zoom" })),
        React.createElement(IconButton, { className: "iconButton", onClick: onZoomOut, title: "Zoom out" },
            React.createElement(Icons, { icon: "zoomout" })),
        React.createElement(IconButton, { className: "iconButton", onClick: onZoomReset, title: "Reset zoom" },
            React.createElement(Icons, { icon: "zoomreset" })),
        React.createElement(WithTooltip, { placement: "bottom", trigger: "click", tooltip: React.createElement(ProfileTooltip, { username: username, onLogout: onLogout }) },
            React.createElement(IconButton, { className: "iconButton", title: "Profile" },
                React.createElement(Icons, { icon: "user" })))));
}
const TooltipTitle = styled.div `
    text-align: center;
`;
const Container = styled.div `
    display: flex;
    button {
        margin-left: 15px;
        color: #999;
    }
`;
const TooltipWrapper = styled.div `
& > div {
  width: auto;
}
`;
